// Essential-routes catalog for the SME-onboarding capability map.
//
// ESSENTIAL_ROUTES is the small, curated surface a new subject-matter expert
// needs to become productive — the SOO-core set — with each route tagged to
// the onboarding journeys it belongs to:
//   J1   — request/deliver work (intake → projects → actions)
//   J2   — see the portfolio + govern data (executive → products → admin)
//   J3   — access, configuration, and adoption (access → custom fields → UAT)
//   core — always-relevant surfaces every journey shares
//
// Every path here MUST be a canonical route declared in rbac.ROUTE_PERMISSIONS
// (never a legacy redirect alias), so the onboarding map can never point at a
// dead or redirect-only destination. navEssentials.test.js enforces that.

export const ESSENTIAL_ROUTES = Object.freeze({
  '/home': { journeys: ['core'] },
  '/notifications': { journeys: ['core'] },
  '/access/status': { journeys: ['J3'] },
  '/help': { journeys: ['core'] },
  '/project-factory': { journeys: ['J1'] },
  '/project-factory/requests/new': { journeys: ['J1'] },
  '/rapids': { journeys: ['core'] },
  // BL-05 (Hugh Burt, TC-PMG1-NAV-003): Ask PRIME is a tour-highlighted core
  // surface — it belongs in the essentials rail, not behind "Show all features".
  '/ai/ask': { journeys: ['core'] },
  '/executive': { journeys: ['J2'] },
  '/loe-dashboard': { journeys: ['J2', 'J3'] },
  '/projects': { journeys: ['J1'] },
  '/actions': { journeys: ['J1'] },
  '/products': { journeys: ['J2'] },
  '/admin/data': { journeys: ['J2'] },
  '/admin/ingestion': { journeys: ['J2'] },
  '/admin/lineage': { journeys: ['J2'] },
  '/admin/site-access': { journeys: ['J3'] },
  '/admin/activity': { journeys: ['J3'] },
  '/admin/custom-fields': { journeys: ['J3'] },
  '/feedback/queue': { journeys: ['J3'] },
  '/uat': { journeys: ['J3'] },
});

// Valid journey tags — the closed set navEssentials.test.js validates against.
export const ESSENTIAL_JOURNEYS = Object.freeze(['J1', 'J2', 'J3', 'core']);

/** Exact-match predicate: is `path` one of the essential onboarding routes? */
export function isEssentialRoute(path) {
  return Object.prototype.hasOwnProperty.call(ESSENTIAL_ROUTES, path);
}
